var userAgent = require('../internals/engine-user-agent');

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/internals/engine-is-ios.js